module.exports = __webpack_public_path__ + "img/SURVEY_ANXIETYSCALE.aa725cdb.png";